const GroupByNoRole = ({ items }) => {
  // Keep only items with a name and no role
  const noRoleItems = items.filter((item) => item && item.name && !item.role);

  return (
    <div>
      {noRoleItems.map((item, i) => (
        <p key={i} className="text-black font-lato-light-important text-base">
          {item.name}
          {item.date ? ` (${item.date})` : ""}
        </p>
      ))}
    </div>
  );
};

export default GroupByNoRole;
